import { getParticipantTeamSide } from '@collector/shared-ui-domain'
import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'

import {
  IncidentQueuePayloadConfig,
  IncidentsQueuePayloadConfig,
} from '../../configuration'

const sharedBreakAfterIncidentConfig: IncidentQueuePayloadConfig = {
  addIncident: (payload, queue) => {
    queue.addIncident({
      ...payload,
      incident_id: BasketballIncidentId.BreakAfter,
    })

    queue.addIncident(payload)
  },
}
export const incidentsQueuePayloadConfig: IncidentsQueuePayloadConfig<BasketballIncidentId> =
  {
    [BasketballIncidentId.BreakAfterFirstQuarter]:
      sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.BreakAfterSecondQuarter]:
      sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.BreakAfterThirdQuarter]:
      sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.BreakAfterFirstHalf]: sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.BreakAfterFirstOvertime]:
      sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.BreakAfterSecondOvertime]:
      sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.BreakAfterThirdOvertime]:
      sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.BreakAfterFourthOvertime]:
      sharedBreakAfterIncidentConfig,
    [BasketballIncidentId.InPossession]: {
      addIncident: (payload, queue, { participant, updateEventSettings }) => {
        queue.addIncident(payload)

        const teamSide = getParticipantTeamSide(participant!)
        updateEventSettings({
          teamSidePossession: teamSide,
        })
      },
    },
  }
